function loginUser({ user }) {
  localStorage.setItem("zaffa-admin", JSON.stringify(user));
}

function removeFromLocalStorage(name) {
  localStorage.removeItem(`${name}`);
}

const LocalstorageService = {
  loginUser,
  removeFromLocalStorage,
};

export default LocalstorageService;
